export default "__VITE_ASSET__BsMmxKHT__"